'use strict';

/**
 * Объект закладки "Состояние" в карточке объекта.
 *
 * @class WebAccess.components.CardTabStateTab
 *
 * @param {string} jobStates Сериализованная (необработанная) модель дерева состояний.
 * @property {number} _currentId Id текущего объекта.
 * @property {string} _currentKind Тип текущего объекта (i.e. task/job).
 * @property {object} _jobStates Расширенная и дополненная модель дерева состояний.
 * @since 5.6.1
 */

window.WebAccess.components.CardTabStateTab = class {

  constructor(jobStates) {
    this._currentId = window.WA.CR.getID();
    if (WA.CR.Type === OBJECT_TYPE.JOB) {
      switch (WA.CR.Kind) {
        case JOB_KIND.JOB:
          this._currentKind = 'JOB';
          break;
        case JOB_KIND.NOTICE:
          this._currentKind = 'NOTICE';
          break;
        case JOB_KIND.CONTROLJOB:
          this._currentKind = 'CONTROLJOB';
          break;
      }
    } else {
      this._currentKind = window.WA.CR.getKind();
    }

    this._jobStates = JSON.parse(jobStates);

    this._initTreeRecursive(
      [...this._jobStates.stateTree],
    );

    this._toggleCollapseTreeNodesRecursive(
      [...this._jobStates.stateTree],
    );

    this._markAndExpandCurrentNode();

    this._shouldScrollToCurrentNode = true;
  }

  /**
   * Получает функции и атрибуты для расширения модели родительской компоненты для прокидывания в React-компоненту.
   *
   * @method WebAccess.components.CardTabStateTab#getExtendedProperties
   * @returns {object} Объект, который будет присвоен атрибуту extended родительской компоненты.
   */
  getExtendedProperties() {
    return {
      initTooltips: () => {
        window.InitAdditionalInfoTooltip($('.hint'));
      },
      L: (res) => {
        return window.L(res);
      },
      toggleCollapsed: (node) => {
        node.collapsed = !node.collapsed;
        $('html').trigger(PAGE_EVENTS.TAB_MODEL_CHANGE);
      },
      scrollToCurrentNode: () => {
        this._scrollToCurrentNode();
      },
    };
  }

  /**
   * Возвращает модель дерева состояний.
   *
   * @method WebAccess.components.CardTabStateTab#getStateTree
   * @returns {object} Обработанная модель дерева состояний.
   */
  getStateTree() {
    return this._jobStates;
  }

  /**
   * Проходит по узлу дерева состояний (и рекурсивно по всем подузлам) и создаёт:
   * а) id каждому узлу (атрибут node.uniqueId),
   * б) ссылку на текущий узел в атрибут _currentNode,
   * в) преобразования статуса ЗЗУ.
   *
   * @method WebAccess.components.CardTabStateTab#_initTreeRecursive
   * @param {array} nodes Список нод текущего узла.
   * @param {object} [parent = null] Родительский узел.
   * @private
   */
  _initTreeRecursive(nodes, parent = null) {
    for (let node of nodes) {
      node.parent = parent;
      // для ускорения рендеринга реакта, формируем уникальный id
      // (нельзя использовать просто id объекта из-за рестартованных задач)
      node.uniqueId = `${parent && parent.id || 0}_${node.id}_${nodes.indexOf(node)}`;

      if (node.children.length) {
        this._initTreeRecursive(node.children, node);
      }

      // установка и разворачивание текущего узла, а так же выделение родительского узла у Заданий и уведомлений.
      if (node.id === this._currentId && node.kind.toUpperCase() === this._currentKind) {
        this._currentNode = node;
      }

      // если родительская задача прекращена, но дочернее задание выполнено, ставим задаче тоже выполнено #26822
      if (node.parent &&
          node.parent.state === WORK_STATE.ABORTED.toString() &&
          node.state === WORK_STATE.DONE.toString()) {
        node.parent.state = node.state;
      }
    }
  }

  /**
   * Проходит по узлу дерева состояний (и рекурсивно по всем подузлам) и расстваляет флаг свернут ли узел
   *
   * @method WebAccess.components.CardTabStateTab#_toggleCollapseTreeNodesRecursive
   * @param {array} nodes Список нод текущего узла.
   * @param {boolean} [isExpanded = false] Значение флага свёрнутости.
   * @private
   */
  _toggleCollapseTreeNodesRecursive(nodes, isExpanded = false) {
    for (let node of nodes) {
      let isNodeExpanded = isExpanded;
      node.collapsed = !isNodeExpanded;
      if (node.children.length) {
        if (node === this._currentNode) {
          isNodeExpanded = true;
        } else if (this._currentNodeParent && node === this._currentNodeParent && this._currentNode.isHidden) {
          isNodeExpanded = true;
        };
        this._toggleCollapseTreeNodesRecursive(node.children, isNodeExpanded);
      }
    }
  }

  /**
   * Помечает (current = true) и разворачивает (collapsed = false) узел дерева, содержащий текущий элемент.
   *
   * @method WebAccess.components.CardTabStateTab#_markAndExpandCurrentNode
   * @private
   */
  _markAndExpandCurrentNode() {
    if (!this._currentNode) {
      return;
    }
    let node = this._currentNode;
    node.current = true;
    if (this._currentKind !== 'TASK') {
      node.parent.current = true;
      this._currentNodeParent = node.parent;
    }
    node.collapsed = false;
    while (node.parent) {
      node = node.parent;
      node.collapsed = false;
    }
  }

  /**
   * Применяет переданное значение фильтра к дереву состояний.
   *
   * @method WebAccess.components.CardTabStateTab#_applyFilter
   * @param {number} filter Значение фильтра.
   * @private
   */
  applyFilter(filter) {
    this._isCurrentNodeHiddenByFilter = false;
    this._shouldScrollToCurrentNode = true;
    this._applyFilterToNodeRecursive(this._jobStates.stateTree, filter);
    this._toggleCollapseTreeNodesRecursive(
      [...this._jobStates.stateTree],
      this._isCurrentNodeHiddenByFilter,
    );
    if (!this._isCurrentNodeHiddenByFilter) {
      this._markAndExpandCurrentNode();
    }
    $('html').trigger(PAGE_EVENTS.TAB_MODEL_CHANGE);
  }

  /**
   * Проходит по узлу дерева состояний и применяет фильтр.
   *
   * @method WebAccess.components.CardTabStateTab#_applyFilterToNodeRecursive
   * @param {array} nodes Список нод текущего узла.
   * @param {number} filter Установленный фильтр.
   * @private
   * @returns {boolean} TRUE если узел виден, иначе - FALSE.
   */
  _applyFilterToNodeRecursive(nodes, filter) {
    let isNodeCompletelyHidden = true;
    for (let node of nodes) {

      switch (filter) {
        case STATETREE_FILTER.RUNNING:
          node.isHidden = (node.state !== WORK_STATE.RUNNING.toString());
          break;
        case STATETREE_FILTER.JOBS:
          node.isHidden = !(node.kind.endsWith('Job'));
          break;
        case STATETREE_FILTER.OUTDATED:
          node.isHidden = (!node.isExpired || node.state === WORK_STATE.ABORTED.toString());
          break;
        case STATETREE_FILTER.UNREAD:
          node.isHidden = (node.isRead !== false);
          break;
        case STATETREE_FILTER.ALL:
        default:
          node.isHidden = false;
      }

      if (node.children.length) {
        const areAllChildrenHidden = this._applyFilterToNodeRecursive(node.children, filter);
        node.isHidden = areAllChildrenHidden && (node.isHidden || node.kind.toUpperCase() === 'TASK');
      }

      if (!node.isHidden) {
        isNodeCompletelyHidden = false;
      } else if (this._currentNodeParent && node === this._currentNodeParent) {
        this._isCurrentNodeHiddenByFilter = true;
      } else if (node === this._currentNode) {
        if (this._currentKind === 'TASK' || !this._currentNodeParent) {
          this._isCurrentNodeHiddenByFilter = true;
        }
      }
    }

    return isNodeCompletelyHidden;
  }

  /**
   * Прокрутка до текущего элемента.
   *
   * @method WebAccess.components.CardTabStateTab#_scrollToCurrentNode
   * @private
   */
  _scrollToCurrentNode() {
    // При первой отрисовке или при применении фильтров сфокусируемся на текущем ЗЗУ в дереве состояний
    // Чтобы скролл больше не повторялся при разворачивании дерева
    if (!this._shouldScrollToCurrentNode) {
      return;
    }
    setTimeout(() => {
      const jContainer = $('#main_container');
      jContainer.scrollTop(0);

      // Получить текущий узел (last - потому, что такой же класс есть и у рожительской задачи текущего ЗЗУ)
      const jCurrentNode = $('.state-tree-element_current:last');
      if (jCurrentNode.length) {
        const currentNodePosition = jCurrentNode.position();
        if (currentNodePosition) {
          const currentNodeTop = currentNodePosition.top;
          jContainer.scrollTop(currentNodeTop);
        }
      }
    }, 0);

    this._shouldScrollToCurrentNode = false;
  }
};
